import type { AcpElicitationOutcome } from '@crowdex/agent-contracts';
import { createContext } from 'react';

export type AgentElicitationContextValue = {
  onAnswer(requestId: string, outcome: AcpElicitationOutcome): void;
};

export const AgentElicitationContext = createContext<AgentElicitationContextValue | null>(null);
